import React, { createContext } from 'react'
import './i18n';  //// import i18n (needs to be bundled ;)) 
import { useTranslation } from 'react-i18next';

import { useAppCtx } from './app-ctx';

/*
export const PriceContext = React.createContext();

export const PriceCtxProvider = ({ children }) => {
  const [failed, setFailed] = React.useState(false);

  return (
    <PriceContext.Provider value={{ failed, setFailed }}>
      {children}
    </PriceContext.Provider>
  );
};
*/

/**
 * NOTE:
 *  Names of (occupacyValue, dietaryValue, dateRangeValue) must match the same names as in 
 *  SearchCriterias object.
 * See:
 *  search-form.js
 * 
 */
export default function ResortPrices({
    className,
    resortId,
    occupacyValue,
    dietaryValue,
    dateRangeValue,
    labelClassName = 'label',
    currencySymbolClassName = 'currency-symbol',
    valueClassName = 'value',
    currencyCodeClassName = 'currency-code'}) {
    const { t } = useTranslation();
    const {JOOMLA_VARS, CONFIG} = useAppCtx();

    // Defensive default: never send an undefined occupancy to the backend
    // (backend requires numeric adults/children).
    const effectiveOccupacy = occupacyValue ?? { adults: 2, children: 1 };

    const [prices, setPrices] = React.useState(null);

    React.useEffect(() => {
        const appRoot = JOOMLA_VARS.root;
        const apiPath = CONFIG.getPrices;

        const payload = {
                resort_id: resortId,
                occupacy:  effectiveOccupacy,
                dietary:   dietaryValue,
                dates:     dateRangeValue
            };

        console.log('ResortPrices.useEffect(): payload:', JSON.stringify(payload));

        // Abort on unmount so a slow price response never hits an unmounted card
        const controller = new AbortController();

        fetch(appRoot + apiPath, {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'X-CSRF-Token': JOOMLA_VARS.csrfToken || ''},
            //resortId, occupacyValue, dietaryValue, dateRangeValue
            body: JSON.stringify(payload),
            signal: controller.signal
        })
        .then(response => response.text())
        .then(text => {
            let data;
            try {
                data = JSON.parse(text);
            } catch (e) {
                console.error("ResortPrices: Failed to parse JSON", e);
                // Optionally handle HTML error response here
                return;
            }

            console.log('ResortPrices.useEffect(): data:', JSON.stringify(data)); 
            if (data.prices) {
                setPrices( {loaded: true, ...data.prices} );
            }

        })
        .catch(error => {
            // Ignore cancellations caused by cleanup (unmount / re-fetch)
            if (error && error.name === 'AbortError') return;
            console.log('ResortPrices.useEffect(): error:', error);
        });

        return () => controller.abort();
    }, []);

    // Do not render "From EUR" when no usable price was returned
    const hasValidPrice = prices && prices.loaded
        && prices.cheapestPrice !== null
        && prices.cheapestPrice !== undefined
        && prices.cheapestPrice !== ''
        && Number(prices.cheapestPrice) > 0;

    return (
        <>
            {hasValidPrice &&
                <span className={className || undefined}>
                    <span className={labelClassName || undefined}>{t('fromWithPrice')}</span>
                    <span className={currencySymbolClassName || undefined}>{prices.currencySymbol}</span>
                    <span className={valueClassName || undefined}>{prices.cheapestPrice}</span>
                    <span className={currencyCodeClassName || undefined}>{prices.currency}</span>
                </span>
            }
        </>
    )
}
